/**
 * Checks if the user has given consent to all cookies using the OneTrust window value.
 * @param {string} oneTrustWindowValue - The value of the OneTrust window.
 * @returns {boolean} - Returns true if the user has given consent to all cookies, otherwise false.
 */
export function checkOneTrustConsentByWindowChange(oneTrustWindowValue) {
    /**
     * @note I moved Vue.config.devtools check here to simplify the high level code using this.
     */

    if (!oneTrustWindowValue) return false;

    /**
     * @note OneTrust is adding cookies by group to OnetrustActiveGroups array.
     * If that array contains less than 4 items - User didn't accept all cookies.
     */
    return (
        oneTrustWindowValue.split(',').filter((item) => item.length).length >= 4
    );
}
